// React Component
import { addAccessToItem } from './helper/utils/addAccessToItems';
import { PermissionV2 } from './helper/permission/enum/PermissionV2';
import { memo } from 'react';

/**
 * @param {String} requiredLevel - minimum permission level required to show feature
 * @param {String[]} inhibitorModifiers - BLOCK feature if current permission has any of these modifiers
 *
 * EG: requiredLevel=UPDATE            -> ONLY if permission >= UPDATE (UPDATE/DELETE), will ALLOW feature
 * EG: inhibitorModifiers=['M3', 'M4'] -> if current permission has either 'M3' or 'M4', will BLOCK feature
 * EG: requiredLevel=CREATE + inhibitorModifiers=['M3', 'M4']
 *          -- Will only show if:
 *              -- current route's permission is >=CREATE (CREATE/UPDATE/DELETE) AND
 *              -- current route's modifiers DOES NOT have both 'M3' and 'M4'
 *
 */
function ActionAccess(props) {
    const {
        permission, subscription, overrideHasSubscription,
        type, requiredLevel, inhibitorModifiers,
        url, children, forceHide,
    } = props;

    if (forceHide)
        return null;

    // console.log('aaa ActionAccess', props);
    const item = addAccessToItem({
        permission,
        inhibitorModifiers,
        subscription,
        overrideHasSubscription,
        transactionType: type,
        requiredLevel,
        url,
    });
    const allowed = !item.isHidden && !item.isLocked;

    return allowed ? children : null;
}

ActionAccess.defaultProps = {
    requiredLevel: PermissionV2.update, // View, Create, Update (Not Delete)
    inhibitorModifiers: [], // eg: if inhibitorModifiers=['M3'] -> if permission has 'M3' will BLOCK feature
};

export default memo(ActionAccess);
